import React from 'react';
import map from 'lodash/map';

import LimitButton from './LimitButton';
import styles from './ProductsPerPage.module.css';

const ProductsPerPage = ({ buttons, limit, onClick }) => (
  <div className={styles.container}>
    {map(buttons, (button) => {
      const { value, width, label } = button;
      return (
        <LimitButton
          key={value}
          value={value}
          isActive={limit === value}
          style={{ width }}
          onClick={onClick}
        >
          {label}
        </LimitButton>
      );
    })}
  </div>
);

export default ProductsPerPage;
